module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b1ccb1d911886b973398e4c4d1a6bb91.png";